import 'react';
import { Text } from 'reaxl';
import { jsx } from 'react/jsx-runtime';
function WalletSymbol(_ref) {
  let {
    color = 'accent',
    weight = 'bold',
    size,
    symbol,
    ...rest
  } = _ref;
  return /*#__PURE__*/jsx(Text, {
    color: color,
    size: size,
    weight: weight,
    ...rest,
    children: symbol
  });
}
export { WalletSymbol as default };
